import { Pipe, PipeTransform } from '@angular/core';
import { ModalMode } from '@utils/enums';

@Pipe({
  name: 'modalMode',
})
export class ModalModePipe implements PipeTransform {
  transform(modalMode: ModalMode | null | undefined, modeToCheck: ModalMode): boolean {
    return modeToCheck == modalMode;
  }
}
